<mat-dialog-content style="height: 78vh;">
    <div layout="row" layout-align="center center">
      <div style="margin-bottom: 2%;">
        <strong>{{titulo}}</strong>
      </div>
    </div>
    <mat-tab-group class="mat-elevation-z8" style="border-radius: 7px;">
        <mat-tab label="General" class="mat-elevation-z8">
            <div style="height: 55vh;">
              <table style="margin-top: 15px; width: 95%; margin-left: 2.5%; margin-right: 2.5%;">
                <tr>
                  <td style="width: 40%;">
                    <mat-form-field style="width: 100%; font-size: 2.0vh;">
                        <input matInput placeholder="Apellido del paciente" 
                            [(ngModel)]=apellido>
                    </mat-form-field>
                  </td>
                  <td style="width: 10%;"></td>
                  <td style="width: 40%;">
                    <mat-form-field style="width: 100%; font-size: 2.0vh;">
                        <input matInput placeholder="Nombre del paciente" 
                            [(ngModel)]=nombre>
                    </mat-form-field>
                  </td>
                </tr>
              </table>
              <table style="width: 95%; margin-left: 2.5%; margin-right: 2.5%;">
                <tr>
                  <td style="width: 10%;">
                    <mat-form-field style="width: 100%; font-size: 2.0vh;">
                        <input matInput placeholder="Fecha de nacimiento" [(ngModel)]=txtFecNac autocomplete="off"
                          mask="00/00/0000">
                    </mat-form-field>
                  </td>
                  <td style="width: 5%;"></td>
                  <td style="width: 15%;">
                    <div [hidden]="tipoDocNombre!=''">
                      <mat-form-field style="width: 80%; font-size: 2.0vh;">
                        <input matInput placeholder="Tipo de documento"
                            [(ngModel)]=txtTipoDoc autocomplete="off"
                            (keydown.enter)="buscarTipoDoc()">
                      </mat-form-field>
                      <i class="fas fa-search" style="font-size: 1.5em; cursor: pointer; color: #4b8cc5;
                          margin-top: 0px;" (click)="buscarTipoDoc()"
                          matTooltip="Buscar tipo de documento">
                      </i>
                    </div>
                    <div [hidden]="tipoDocNombre==''" style="text-align: end; margin-right: 5px;">
                      <i class="fas fa-trash" style=" margin-right: 5px;
                          font-size: 1.5em; cursor: pointer; color: #4b8cc5;
                          margin-top: 0px;" (click)="eliminarTipoDoc()"
                          matTooltip="Eliminar tipo de documento">
                      </i>
                      <mat-label>{{tipoDocNombre}}:</mat-label>
                    </div>
                  </td>
                  <td style="width: 15%;">
                    <mat-form-field style="width: 100%; font-size: 2.0vh;">
                        <input matInput placeholder="Nº de documento" [(ngModel)]=txtNumDoc autocomplete="off"
                          mask="00000000">
                    </mat-form-field>
                  </td>
                  <td style="width: 5%;"></td>
                  <td style="width: 15%;">
                    <div [hidden]="tipoSexoNombre!=''">
                      <mat-form-field style="width: 80%; font-size: 2.0vh;">
                        <input matInput placeholder="Sexo"
                            [(ngModel)]=txtTipoSexo autocomplete="off"
                            (keydown.enter)="buscarTipoSexo()">
                      </mat-form-field>
                      <i class="fas fa-search" style="font-size: 1.5em; cursor: pointer; color: #4b8cc5;
                          margin-top: 0px;" (click)="buscarTipoSexo()"
                          matTooltip="Buscar sexo">
                      </i>
                    </div>
                    <div [hidden]="tipoSexoNombre==''" style="text-align: end; margin-right: 5px;">
                      <i class="fas fa-trash" style=" margin-right: 5px;
                          font-size: 1.5em; cursor: pointer; color: #4b8cc5;
                          margin-top: 0px;" (click)="eliminarTipoSexo()"
                          matTooltip="Eliminar tipo de sexo">
                      </i>
                      <mat-label>{{tipoSexoNombre}}</mat-label>
                    </div>
                  </td>
                  <td style="width: 35%;"></td>
                </tr>
              </table>
              <table style="width: 95%; margin-left: 2.5%; margin-right: 2.5%;">
                <tr>
                  <td style="width: 100%;">
                    <mat-form-field class="example-full-width" style="width: 95%; font-size: 2.0vh;">
                        <mat-label>Observaciones:</mat-label>
                        <textarea matInput rows="4" autocomplete="off"
                          [(ngModel)]="txtObservaciones"></textarea>
                    </mat-form-field>
                  </td>
                </tr>
              </table>
            </div>
        </mat-tab>
        <mat-tab label="Domicilios" class="mat-elevation-z8">
          <div style="height: 55vh; ">
            <button mat-raised-button class="btn-agregar" 
            (click)="modificarDomicilio('00000000-0000-0000-0000-000000000000','','','','','','','','','','')"
                style="margin-top: 1vh; width: auto; padding-left: 10px; padding-right: 10px;
                  margin-left: 20px; margin-top: 20px;">
                Agregar domicilio
            </button>
            <div style="margin-left: 5%; margin-right: 5%; padding: 10px;
              text-align: center;" [hidden]="escondeFraseNoHayDomicilios">
                <h4 style="color: #a31611;"><b>Todavía no se agregó ningún domicilio</b></h4>
            </div>
            <div style="margin-left: 5%; margin-right: 5%; padding-left: 20px; padding-right: 20px;" 
                [hidden]="!escondeFraseNoHayDomicilios">
                <div fxLayout fxLayoutAlign="center center">
                    <mat-form-field fxFlex="40%">
                      <input matInput type="text" (keyup)="buscarDomicilio($any($event.target).value)" placeholder="Búsqueda"
                        autocomplete="off"> 
                    </mat-form-field>
                </div>
                <table mat-table [dataSource]="dataSourceDomicilios" class="mat-elevation-z8" style="width: 100%;">
                    <ng-container matColumnDef="acciones">
                        <th mat-header-cell *matHeaderCellDef style="width:10%;"> Acciones </th>
                        <td mat-cell *matCellDef="let element">
                            <i class="fas fa-pencil-alt" style="width: 10px; margin-right:5%;
                                font-size: 1.5em; cursor: pointer; color: #4b8cc5;
                                margin-top: 0px; margin-right: 3vw;"
                                (click)="modificarDomicilio(element.idDomicilio,element.idTipoDomicilio, element.nombreTipoDomicilio
                                  ,element.calle, element.num, element.piso, element.depto, element.idProvincia
                                  ,element.nombreProvincia, element.idLocalidad, element.nombreLocalidad)"
                            ></i>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="fecha" style="width:10%;">
                        <th mat-header-cell *matHeaderCellDef> Fecha</th>
                        <td mat-cell *matCellDef="let element">
                        {{element.fecha}}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="nombreTipoDomicilio" style="width:10%;">
                        <th mat-header-cell *matHeaderCellDef> Tipo</th>
                        <td mat-cell *matCellDef="let element">
                        {{element.nombreTipoDomicilio}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="domMostrar" style="width:10%;">
                        <th mat-header-cell *matHeaderCellDef> Domicilio</th>
                        <td mat-cell *matCellDef="let element">
                        {{element.domMostrar}}
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumnsDomicilios;"></tr>">
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsDomicilios;"></tr>
                </table>
                <mat-paginator #paginadorDomicilios [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Mails" class="mat-elevation-z8">
          <div style="height: 55vh; ">
            <button mat-raised-button class="btn-agregar" 
            (click)="modificarMail('00000000-0000-0000-0000-000000000000','','','')"
                style="margin-top: 1vh; width: auto; padding-left: 10px; padding-right: 10px;
                  margin-left: 20px; margin-top: 20px;">
                Agregar mail
            </button>
            <div style="margin-left: 5%; margin-right: 5%; padding: 10px;
              text-align: center;" [hidden]="escondeFraseNoHayMails">
                <h4 style="color: #a31611;"><b>Todavía no se agregó ningún mail</b></h4>
            </div>
            <div style="margin-left: 5%; margin-right: 5%; padding-left: 20px; padding-right: 20px;" 
                [hidden]="!escondeFraseNoHayMails">
                <div fxLayout fxLayoutAlign="center center">
                    <mat-form-field fxFlex="40%">
                      <input matInput type="text" (keyup)="buscarMail($any($event.target).value)" placeholder="Búsqueda"
                        autocomplete="off"> 
                    </mat-form-field>
                </div>
                <table mat-table [dataSource]="dataSourceMails" class="mat-elevation-z8" style="width: 100%;">
                  <ng-container matColumnDef="acciones">
                      <th mat-header-cell *matHeaderCellDef style="width:10%;"> Acciones </th>
                      <td mat-cell *matCellDef="let element">
                          <i class="fas fa-pencil-alt" style="width: 10px; margin-right:5%;
                              font-size: 1.5em; cursor: pointer; color: #4b8cc5;
                              margin-top: 0px; margin-right: 3vw;"
                              (click)="modificarMail(element.idMail,element.idTipoMail
                                ,element.nombreTipoMail, element.mail)"
                          ></i>
                      </td>
                  </ng-container>
                  <ng-container matColumnDef="fecha" style="width:10%;">
                    <th mat-header-cell *matHeaderCellDef> Fecha</th>
                    <td mat-cell *matCellDef="let element">
                    {{element.fecha}}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="nombreTipoMail" style="width:10%;">
                    <th mat-header-cell *matHeaderCellDef> Tipo</th>
                    <td mat-cell *matCellDef="let element">
                    {{element.nombreTipoMail}}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="mail" style="width:10%;">
                      <th mat-header-cell *matHeaderCellDef> Mail</th>
                      <td mat-cell *matCellDef="let element">
                      {{element.mail}}
                      </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumnsMails;"></tr>">
                  <tr mat-row *matRowDef="let row; columns: displayedColumnsMails;"></tr>
                </table>
                <mat-paginator #paginadorMails [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Teléfonos" class="mat-elevation-z8">
          <div style="height: 55vh; ">
            <button mat-raised-button class="btn-agregar" 
            (click)="modificarTelefono('00000000-0000-0000-0000-000000000000','','','')"
                style="margin-top: 1vh; width: auto; padding-left: 10px; padding-right: 10px;
                  margin-left: 20px; margin-top: 20px;">
                Agregar teléfono
            </button>
            <div style="margin-left: 5%; margin-right: 5%; padding: 10px;
              text-align: center;" [hidden]="escondeFraseNoHayTelefono">
                <h4 style="color: #a31611;"><b>Todavía no se agregó ningún teléfono</b></h4>
            </div>
            <div style="margin-left: 5%; margin-right: 5%; padding-left: 20px; padding-right: 20px;" 
                [hidden]="!escondeFraseNoHayTelefono">
                <div fxLayout fxLayoutAlign="center center">
                    <mat-form-field fxFlex="40%">
                      <input matInput type="text" (keyup)="buscarTelefono($any($event.target).value)" placeholder="Búsqueda"
                        autocomplete="off"> 
                    </mat-form-field>
                </div>
                <table mat-table [dataSource]="dataSourceTelefonos" class="mat-elevation-z8" style="width: 100%;">
                  <ng-container matColumnDef="acciones">
                      <th mat-header-cell *matHeaderCellDef style="width:10%;"> Acciones </th>
                      <td mat-cell *matCellDef="let element">
                          <i class="fas fa-pencil-alt" style="width: 10px; margin-right:5%;
                              font-size: 1.5em; cursor: pointer; color: #4b8cc5;
                              margin-top: 0px; margin-right: 3vw;"
                              (click)="modificarTelefono(element.idTelefono,element.idTipoTelefono
                                ,element.nombreTipoTelefono, element.telefono)"
                          ></i>
                      </td>
                  </ng-container>
                  <ng-container matColumnDef="fecha" style="width:10%;">
                    <th mat-header-cell *matHeaderCellDef> Fecha</th>
                    <td mat-cell *matCellDef="let element">
                    {{element.fecha}}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="nombreTipoTelefono" style="width:10%;">
                    <th mat-header-cell *matHeaderCellDef> Tipo</th>
                    <td mat-cell *matCellDef="let element">
                    {{element.nombreTipoTelefono}}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="telefono" style="width:10%;">
                      <th mat-header-cell *matHeaderCellDef> Teléfono</th>
                      <td mat-cell *matCellDef="let element">
                      {{element.telefono}}
                      </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumnsTelefonos;"></tr>">
                  <tr mat-row *matRowDef="let row; columns: displayedColumnsTelefonos;"></tr>
                </table>
                <mat-paginator #paginadorTelefonos [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="WhatsAPP" class="mat-elevation-z8">
          <div style="height: 55vh; ">
            <button mat-raised-button class="btn-agregar" 
            (click)="modificarWhatsAPP('00000000-0000-0000-0000-000000000000','')"
                style="margin-top: 1vh; width: auto; padding-left: 10px; padding-right: 10px;
                  margin-left: 20px; margin-top: 20px;">
                Agregar WhatsAPP
            </button>
            <div style="margin-left: 5%; margin-right: 5%; padding: 10px;
              text-align: center;" [hidden]="escondeFraseNoHayWhatsAPP">
                <h4 style="color: #a31611;"><b>Todavía no se agregó ningún WhatsAPP</b></h4>
            </div>
            <div style="margin-left: 5%; margin-right: 5%; padding-left: 20px; padding-right: 20px;" 
                [hidden]="!escondeFraseNoHayWhatsAPP">
                <div fxLayout fxLayoutAlign="center center">
                    <mat-form-field fxFlex="40%">
                      <input matInput type="text" (keyup)="buscarWhatsAPP($any($event.target).value)" placeholder="Búsqueda"
                        autocomplete="off"> 
                    </mat-form-field>
                </div>
                <table mat-table [dataSource]="dataSourceWhatsAPP" class="mat-elevation-z8" style="width: 100%;">
                  <ng-container matColumnDef="acciones">
                      <th mat-header-cell *matHeaderCellDef style="width:10%;"> Acciones </th>
                      <td mat-cell *matCellDef="let element">
                          <i class="fas fa-pencil-alt" style="width: 10px; margin-right:5%;
                              font-size: 1.5em; cursor: pointer; color: #4b8cc5;
                              margin-top: 0px; margin-right: 3vw;"
                              (click)="modificarWhatsAPP(element.idWhatsAPP,element.whatsAPP)"
                          ></i>
                      </td>
                  </ng-container>
                  <ng-container matColumnDef="fecha" style="width:10%;">
                    <th mat-header-cell *matHeaderCellDef> Fecha</th>
                    <td mat-cell *matCellDef="let element">
                    {{element.fecha}}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="whatsAPP" style="width:10%;">
                    <th mat-header-cell *matHeaderCellDef> WhatsAPP</th>
                    <td mat-cell *matCellDef="let element">
                    {{element.whatsAPP}}
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumnsWhatsAPP;"></tr>">
                  <tr mat-row *matRowDef="let row; columns: displayedColumnsWhatsAPP;"></tr>
                </table>
                <mat-paginator #paginadorWhatsAPP [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Obras sociales" class="mat-elevation-z8">
          <div style="height: 55vh; ">
            <button mat-raised-button class="btn-agregar" 
            (click)="modificarObraSocial('00000000-0000-0000-0000-000000000000','','','','','','')"
                style="margin-top: 1vh; width: auto; padding-left: 10px; padding-right: 10px;
                  margin-left: 20px; margin-top: 20px;">
                Agregar Obra Social
            </button>
            <div style="margin-left: 5%; margin-right: 5%; padding: 10px;
              text-align: center;" [hidden]="escondeFraseNoHayObraSocial">
                <h4 style="color: #a31611;"><b>Todavía no se agregó ninguna obra social</b></h4>
            </div>
            <div style="margin-left: 5%; margin-right: 5%; padding-left: 20px; padding-right: 20px;" 
                [hidden]="!escondeFraseNoHayObraSocial">
                <div fxLayout fxLayoutAlign="center center">
                    <mat-form-field fxFlex="40%">
                      <input matInput type="text" (keyup)="buscarObraSocial($any($event.target).value)" placeholder="Búsqueda"
                        autocomplete="off"> 
                    </mat-form-field>
                </div>
                <table mat-table [dataSource]="dataSourceObraSocial" class="mat-elevation-z8" style="width: 100%;">
                  <ng-container matColumnDef="acciones">
                      <th mat-header-cell *matHeaderCellDef style="width:10%;"> Acciones </th>
                      <td mat-cell *matCellDef="let element">
                          <i class="fas fa-pencil-alt" style="width: 10px; margin-right:5%;
                              font-size: 1.5em; cursor: pointer; color: #4b8cc5;
                              margin-top: 0px; margin-right: 3vw;"
                              (click)="modificarObraSocial(element.idObraSocialPaciente,element.idObraSocial
                                ,element.nombreObraSocial,element.idPlan, element.nombrePlan
                                ,element.numAfiliado, element.tipoGravado)"
                          ></i>
                      </td>
                  </ng-container>
                  <ng-container matColumnDef="fecha" style="width:10%;">
                    <th mat-header-cell *matHeaderCellDef> Fecha</th>
                    <td mat-cell *matCellDef="let element">
                    {{element.fecha}}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="frase" style="width:10%;">
                    <th mat-header-cell *matHeaderCellDef> Obra Social</th>
                    <td mat-cell *matCellDef="let element">
                    {{element.frase}}
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumnsOBRASOCIAL;"></tr>">
                  <tr mat-row *matRowDef="let row; columns: displayedColumnsOBRASOCIAL;"></tr>
                </table>
                <mat-paginator #paginadorOBRASOCIAL [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
            </div>
          </div>
        </mat-tab>
    </mat-tab-group>
</mat-dialog-content>
<div style="text-align: center;">
    <table style="width: 100%; text-align: center;">
      <tr>
        <td style="width: 30%;">
          <button mat-raised-button class="btn-agregar" (click)="cerrar('cancela')">
            <i class="fas fa-arrow-circle-left fa-1x" style="width: 20px; margin-right:10px;
                                    font-size: 1.5em; cursor: pointer;"></i>
            Cancelar
          </button>
        </td>
        <td style="width: 20%;"></td>
        <td style="width: 30%;">
          <button mat-raised-button class="btn-agregar" (click)="almacenar()" style="margin-left: 30px;">
            <i class="fas fa-save fa-1x" style="width: 20px; margin-right:10px;
                                    font-size: 1.5em; cursor: pointer;"></i>
            Almacenar
          </button>
        </td>
      </tr>
    </table>
  </div>
